/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getHead.defs.js'
export { main as default } from './getHead.defs.js'
